export default "__VITE_ASSET__DnFKD_n9__"